import { Autocomplete, Button, Checkbox, Chip, FormControl, FormControlLabel, FormGroup,InputLabel,MenuItem,Select,TextareaAutosize, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Stack } from '@mui/system';
import { Image } from 'cloudinary-react'
import { useAddGroupMutation, useAddPhonecaseMutation, useGetAllBrandsQuery, useGetAllColorsQuery, useGetAllGroupsQuery, useGetAllMaterialsQuery, useGetAllModelsQuery } from '../../../../features/fullApi'
import { basicSchema } from "./validation";
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';

const CreatePhonecase = ({getPhonecases}) => { 

  window.scrollTo(0,0)
  const [selectedFile, setSelectedFile] = useState([]);
  const [brand, setBrand] = useState("");
  const [color, setColor] = useState("");
  const [material, setMaterial] = useState("");
  const [model, setModel] = useState("");

  const {data: brands, error: brandsError, isLoading: isLoadingBrands} = useGetAllBrandsQuery()
  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()
  const {data: materials, error: materialsError, isLoading: isLoadingMaterials} = useGetAllMaterialsQuery()
  const {data: models, error: modelsError, isLoading: isLoadingModels} = useGetAllModelsQuery()
  const {data: groups, error: groupsError, isLoading: isLoadingGroups} = useGetAllGroupsQuery()

  useEffect(() => {
    values.brands = brands
  }, [brands])

  useEffect(() => {
    values.materials = materials
  }, [materials])

  useEffect(() => {
    values.colors = colors
  }, [colors])

  useEffect(() => {
    values.models = models
  }, [models])

  const handleBrand = (event) => {
    setBrand(event.target.value);
  };

  const handleColor = (event) => {
    setColor(event.target.value);
  };

  const handleMaterial = (event) => {
    setMaterial(event.target.value);
  };

  const handleModel = (event) => {
    setModel(event.target.value);
  };
  
  const user = JSON.parse(localStorage.getItem('user'))

  const [phonecaseImgLink, setPhonecaseImgLink] = useState("")
  const [showBtn, setShowBtn] = useState(false)

  const uploadImage = async () => {
    const formData = new FormData()
    formData.append("file", selectedFile)
    formData.append("upload_preset", "zt8iigue")
    const data = await axios.post("https://api.cloudinary.com/v1_1/deqqgmfxk/image/upload", formData)
    .then(res => {
      setPhonecaseImgLink(res.data.secure_url)
      setShowBtn(true)
    })
  };

    //constructing the boolean colors checked array
    const [groupsObj, setGroupsObj] = useState({})
  
        useEffect(() => {
          if(!isLoadingGroups) {
            console.log("GROUPS#####", groups)
            Object.keys(groups).forEach(ele => {
              let key = groups[ele].groupName
                groupsObj[key] = groups[ele]._id;
            });
          }
        }, [groups, isLoadingGroups])

  const [addPhonecase] = useAddPhonecaseMutation()
  const [addGroup] = useAddGroupMutation()

  const onSubmit = async(values, actions) => {
      if(groupsObj[brand.brandName + " " + model.modelName + " " + material.materialName]?.length>0) {
          console.log("GROUP EXISTS")
          addPhonecase({title: "Case " + brand.brandName + " " + model.modelName  + " " + color.colorName + " " + material.materialName, desc: values.desc, groupId: groupsObj[brand.brandName + " " + model.modelName + " " + material.materialName], brandId: brand._id, colorId: color._id, modelId: model._id, materialId: material._id, price: values.price, quantity: values.quantity, img: phonecaseImgLink}, { 
            headers: {
              'Token': `Bearer ${user?.accessToken}`
            }
          })
          .then(res => {
            toast.success(`${"Case " + brand.brandName + " " + model.modelName  + " " + color.colorName + " " + material.materialName} successfully created`)
          })
          .catch((e) => {
            toast("Phonecase already exists")
          })
      } else {
        addGroup({groupName:brand.brandName + " " + model.modelName + " " + material.materialName})
        .then(res => {
          addPhonecase({title: "Case " + brand.brandName + " " + model.modelName  + " " + color.colorName + " " + material.materialName, desc: values.desc, groupId: res.data._id, brandId: brand._id, colorId: color._id, modelId: model._id, materialId: material._id, price: values.price, quantity: values.quantity, img: phonecaseImgLink}, { 
            headers: {
              'Token': `Bearer ${user?.accessToken}`
            }
          })
          .then(res => {
            toast.success(`${"Case " + brand.brandName + " " + model.modelName  + " " + color.colorName + " " + material.materialName} successfully created`)
            console.log("RES###", res.data)
          })
          .catch((e) => {
            toast("Product already exists")
            console.log("e is", e)
          })
        })
        .catch(err => {
          console.log("error when creating new group")
        })
    }
    navigate('/phonecases/1')
  }
 


  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: "",
      desc: "",
      img: "",
      brand: "",
      color: "",
      price: "",
      material: "",
      model: "",
      quantity: "",
    },
    validationSchema: basicSchema,
    onSubmit,
  });
  console.log("VALUES###", values)
  const navigate = useNavigate()

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));


  const renderMobileCreatePhonecase = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""} style={{width:'100%', height:'100%'}}>
      <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off" id="registerForm">
        <h3 className="center">Add New Phonecase</h3>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
          <TextField
            id="desc"
            type="text"
            margin="dense"
            value={values.desc}
            onChange={handleChange}
            onBlur={handleBlur}
            label="desc"
            multiline
            rows={5}
          />
        </FormControl>

        {errors.desc && touched.desc && (
          <p className="error">{errors.desc}</p>
        )}

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px'}}>
        {phonecaseImgLink &&  <Image cloudName="deqqgmfxk"  publicId={phonecaseImgLink} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>
        }
      </div>
        <Stack direction="row" justifyContent="space-between" sx={{marginBottom: '10px'}}>
          <Button  sx={{width: '150px'}} variant="contained" color="secondary" size="small" component="label">
            Upload
            <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
          </Button>
          <Button variant="contained" size="small" sx={{width: '150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
        </Stack>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <InputLabel id="brand">Brand</InputLabel>
              <Select
                id="brand"
                value={brand}
                label="Brand"
                onChange={handleBrand}
                name="brand"
              >
              {brands?.map((option) => (
                <MenuItem key={option._id} value={option}>
                  {option.brandName}
                </MenuItem>
              ))}
            </Select>
        </FormControl>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                    <InputLabel id="color">Color</InputLabel>
                    <Select
                      id="color"
                      value={color}
                      label="Color"
                      onChange={handleColor}
                      name="color"
                    >
                        {colors?.map((option) => (
                        <MenuItem key={option._id} value={option}>
                          {option.colorName}
                        </MenuItem>
                      ))}
                    </Select>
        </FormControl>

        <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="material">Material</InputLabel>
                  <Select
                    id="material"
                    value={material}
                    label="Material"
                    onChange={handleMaterial}
                    name="material"
                  >
                      {materials?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.materialName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
          size="small"
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}
        
    <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
      <TextField
          id="price"
          type="number"
          margin="dense"
          size="small"
          value={values.price}
          onChange={handleChange}
          onBlur={handleBlur}
          label="Price"
        />
    </FormControl>

        {errors.price && touched.price && (
          <p className="error">{errors.price}</p>
        )}

        <div className="btnContainer">
          <Stack direction="row" spacing={2}>
            {showBtn ?
                (<Button variant="contained" size="small" color="primary" id="submitBtn" type="submit">
                Create
              </Button>) : <Typography variant="subtitle2">Please upload an image in order to submit</Typography>
            } 
            <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/phonecases/1")}>
            Shop
            </Button>
          </Stack>
        </div>
      </form>
    </div>
  )

  const renderDesktopCreatePhonecase = () => (
    <div id="formContainer" className={isMd ? "mobile" : ""}>
    <form onSubmit={handleSubmit} action="/upload" encType="multipart/form-data" autoComplete="off" id="registerForm">
      <h1 className="center">Add New Phonecase</h1>
      <Chip label="The name will be auto-generated" color="secondary" sx={{marginBottom:'10px'}}/>
      <TextField
        id="desc"
        type="text"
        margin="dense"
        value={values.desc}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Description"
        multiline
        rows={5}
      />
      {errors.desc && touched.desc && (
        <p className="error">{errors.desc}</p>
      )}

      {phonecaseImgLink &&  <Image cloudName="deqqgmfxk"  publicId={phonecaseImgLink} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      }

      <Stack sx={{display:'flex', alignItems:'center', justifyContent:'space-between', margin:'10px 0'}} direction="row">
        <Button variant="contained" color="secondary" component="label" sx={{width:'150px'}}>
          Upload
          <input hidden accept="image/*" multiple type="file" name="img" id="input" onChange={onFileChange}/>
        </Button>
        <Button variant="contained" sx={{width:'150px'}} onClick={() => uploadImage()}>Save to cloud</Button>
      </Stack>
      
      <Chip label="Upload an image and then save it in the cloud" color="primary" sx={{margin:'10px 0'}}/>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="brand">Brand</InputLabel>
                  <Select
                    id="brand"
                    value={brand}
                    label="Brand"
                    onChange={handleBrand}
                    name="brand"
                  >
                      {brands?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.brandName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="color">Color</InputLabel>
                  <Select
                    id="color"
                    value={color}
                    label="Color"
                    onChange={handleColor}
                    name="color"
                  >
                      {colors?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.colorName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>


      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="material">Material</InputLabel>
                  <Select
                    id="material"
                    value={material}
                    label="Material"
                    onChange={handleMaterial}
                    name="material"
                  >
                      {materials?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.materialName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
                  <InputLabel id="model">Model</InputLabel>
                  <Select
                    id="model"
                    value={model}
                    label="Model"
                    onChange={handleModel}
                    name="model"
                  >
                      {models?.map((option) => (
                      <MenuItem key={option._id} value={option}>
                        {option.modelName}
                      </MenuItem>
                    ))}
                  </Select>
      </FormControl>

      <FormControl fullWidth style={{marginBottom: '10px'}}>
      <TextField
          id="quantity"
          type="number"
          margin="dense"
          value={values.quantity}
          onChange={handleChange}
          onBlur={handleBlur}
          label={"Quantity"}
        />
      </FormControl>
      {errors.quantity && touched.quantity && (
        <p className="error">{errors.quantity}</p>
      )}
      

    <TextField
        id="price"
        type="number"
        margin="dense"
        value={values.price}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Price"
      />
      {errors.price && touched.price && (
        <p className="error">{errors.price}</p>
      )}

      <div className="btnContainer">
        <Stack direction="row" spacing={2}>
          {showBtn ?
              (<Button variant="contained" size="small" color="primary" id="submitBtn" type="submit">
              Create
            </Button>) : "Please upload a phonecase image and you will be able to submit"
          } 
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/phonecases/1")}>
          Shop
          </Button>
        </Stack>
      </div>
    </form>
    </div>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileCreatePhonecase() : 
        (isSm) ? renderMobileCreatePhonecase() :
        (isMd) ? renderMobileCreatePhonecase() :
        renderDesktopCreatePhonecase()
      }
    </div>
  );
}

export default CreatePhonecase